export var DOCUMENT_DELETED = 'Dokumentum törölve!';
export var TASK_CREATED = 'Ticket rögzítve!';
export var COPIED_TO_CLIPBOARD = 'Szöveg a vágólapra helyezve!';
export var LOCAL_LINK_COPIED_TO_CLIPBOARD = 'A dokumentum lokális linkje a vágólapra helyezve!';
export var TASK_NOTE_CLOSING_PROMPT = 'A megjegyzést nem küldted el! Biztosan bezárod a feladat ablakot?';
export var GIT_BRANCH_COPIED_TO_CLIPBOARD = 'Git branch név a vágólapra másolva!';
export var TASK_DELETING_NOT_ALLOWED = 'A feladat nem törölhető, mert rendelkezik rögzített idővel!';



//////////////////
// WEBPACK FOOTER
// ./src/constants/messages.ts
// module id = 53
// module chunks = 0